import globals from "../config/appconfig";
import axios from "axios";
import Utils from "../utils/Utils";
import moment from "moment";

export default class DizionariService {

    static urlMalattie = globals["app-url-backend-malattie"] + "/malattie";

    static urlComuni = globals["app-url-backend-toponomastica"] + "/comuni";
    static urlProvince = globals["app-url-backend-toponomastica"] + "/province";
    static urlNazioni = globals["app-url-backend-toponomastica"] + "/nazioni";
    static urlSiglaProvince = globals["app-url-backend-toponomastica"] + "/sigleProvince";
    static urlStruttureAndStabilimenti = globals["app-url-backend-strutture"] + "/strutture/strutturestabilimenti";
    static urlReparti = globals["app-url-backend-strutture"] + "/strutture/reparti"
    static urlMalattieUtenteLaboratorio = globals["app-url-backend-malattie"] + "/malattie/utentelaboratorio";
    static urlToponomastica=globals["app-url-backend-toponomastica"]
    static urlGetAulssPerComuni=globals["app-url-backend-toponomastica"]+"/comuni/comuniaulss"
    static urlGetComuniPerAulss=globals["app-url-backend-toponomastica"]+"/aulss/comuniPerAulss"
    static urlAulss=globals["app-url-backend-toponomastica"]+"/aulss"



    static getMalattie() {

        return axios.get(DizionariService.urlMalattie).then(data => {
            if (data) {
                console.log("[DEBUG] Malattie retrieved with success");

                let malattie = Utils.addFieldToArrayObjects(data.data, "descrizione", "codice", "codDesc");
                let malattieOrdinate = malattie.sort((a,b) => (a.descrizione > b.descrizione) ? 1 : ((b.descrizione > a.descrizione) ? -1 : 0))
                let codiceMap = Utils.arrayToMap(malattieOrdinate, "codice");
                let descrizioneMap = Utils.arrayToMap(malattieOrdinate, "descrizione");
                let malattieExport = malattie.filter(mal => mal.descrizione !== "USUTU" && mal.codice !== "0384G2" && mal.codice !== "0384G3" && mal.codice !== "0384G4"
                                                            && mal.codice !== "0384G5" && mal.codice !== "0384G" && mal.codice !== "03841" && mal.codice !== "0384G6"
                                                            && mal.codice !== "0384EC" && mal.codice !== "0384G7" && mal.codice !== "0384G8" && mal.codice !== "0384G9"
                                                            && mal.codice !== "0384G10" && mal.codice !== "0362" && mal.codice !== "0384G11" && mal.codice !== "0382"
                                                            && mal.codice !== "0384G12" && mal.codice !== "0381" && mal.codice !== "0380" && mal.codice !== "0384G13"
                                                            && mal.codice !== "3209" && mal.codice !== "3210" && mal.codice !== "3200" && mal.codice !== "10081"
                                                            && mal.codice !== "3201" && mal.codice !== "3213" && mal.codice !== "360" && mal.codice !== "942"
                                                            && mal.codice !== "3203" && mal.codice !== "3202");
                sessionStorage.setItem("malattieExport", JSON.stringify(malattieExport));
                sessionStorage.setItem("malattie", JSON.stringify(malattieOrdinate));
                sessionStorage.setItem("malattiePerCodice", JSON.stringify(codiceMap));
                sessionStorage.setItem("malattiePerDescrizione", JSON.stringify(descrizioneMap));

                console.log("[DEBUG] Get Malattie to SessionStorage");
            }
        }).catch(
            console.log("[ERROR] get Malattie to SessionStorage")
        );


    }

    static getMalattieUtenteLaboratorio() {

        return axios.get(DizionariService.urlMalattieUtenteLaboratorio).then(data => {
            if (data) {
                console.log("[DEBUG] Malattie Utente Laboratorio retrieved with success");

                let malattieUtenteLaboratorio = Utils.addFieldToArrayObjects(data.data, "descrizione", "codice", "codDesc");
                let descrizioneMalattieUtenteLaboratorioMap = Utils.arrayToMap(malattieUtenteLaboratorio, "descrizione");
                let codiceMalattieUtenteLaboratorioMap = Utils.arrayToMap(malattieUtenteLaboratorio, "codice");
                sessionStorage.setItem("malattieUtenteLaboratorio", JSON.stringify(malattieUtenteLaboratorio));
                sessionStorage.setItem("malattieUtenteLaboratorioPerDescrizione", JSON.stringify(descrizioneMalattieUtenteLaboratorioMap));
                sessionStorage.setItem("malattieUtenteLaboratorioPerCodice", JSON.stringify(codiceMalattieUtenteLaboratorioMap));

                console.log("[DEBUG] Get Malattie Utente Laboratorio to SessionStorage");
            }
        }).catch(
            console.log("[ERROR] Get Malattie Utente Laboratorio to SessionStorage")
        );
    }

    static getMalattiePerFocolai() {

        return axios.get(DizionariService.urlMalattie.concat("/malattiefocolai")).then(data => {
            if (data) {
                console.log("[DEBUG] Malattie retrieved with success");
                let malattieFocolai = Utils.addFieldToArrayObjects(data.data, "descrizione", "codice", "codDesc");
                malattieFocolai = malattieFocolai.filter(mal => mal.descrizione !== "USUTU" && mal.codice !== "0384G2" && mal.codice !== "0384G3" && mal.codice !== "0384G4"
                                        && mal.codice !== "0384G5" && mal.codice !== "0384G" && mal.codice !== "03841" && mal.codice !== "0384G6"
                                        && mal.codice !== "0384EC" && mal.codice !== "0384G7" && mal.codice !== "0384G8" && mal.codice !== "0384G9"
                                        && mal.codice !== "0384G10" && mal.codice !== "0362" && mal.codice !== "0384G11" && mal.codice !== "0382"
                                        && mal.codice !== "0384G12" && mal.codice !== "0381" && mal.codice !== "0380" && mal.codice !== "0384G13"
                                        && mal.codice !== "3209" && mal.codice !== "3210" && mal.codice !== "3200" && mal.codice !== "10081"
                                        && mal.codice !== "3201" && mal.codice !== "3213" && mal.codice !== "360" && mal.codice !== "942"
                                        && mal.codice !== "3203" && mal.codice !== "3202");
                let codiceFocolaiMap = Utils.arrayToMap(malattieFocolai, "codice");
                let descrizioneFocolaiMap = Utils.arrayToMap(malattieFocolai, "descrizione");
                sessionStorage.setItem("malattieFocolai", JSON.stringify(malattieFocolai));
                sessionStorage.setItem("malattieFocolaiPerCodice", JSON.stringify(codiceFocolaiMap));
                sessionStorage.setItem("malattieFocolaiPerDescrizione", JSON.stringify(descrizioneFocolaiMap));
                console.log("[DEBUG] Get MalattieFocolai to SessionStorage");
            }
        }).catch(
            console.log("[ERROR] get MalattieFocolai to SessionStorage")
        );


    }


    static getProvince() {

        axios.get(DizionariService.urlProvince).then(data => {
            if (data) {
                console.log("[DEBUG] Province retrieved with success");

                let province = Utils.addFieldToArrayObjects(data.data, "descrizione", "dataInizioValidita", "dataFineValidita", "codice");
                let codiceMap = Utils.arrayToMap(province, "codice");

                sessionStorage.setItem("province", JSON.stringify(province));
                sessionStorage.setItem("provincePerCodice", JSON.stringify(codiceMap));


                console.log("[DEBUG] Get province to SessionStorage");
            }
        }).catch(
            console.log("[ERROR] Get Province to SessionStorage")
        );
    }

    static getNazioni() {

        axios.get(DizionariService.urlNazioni).then(data => {
            if (data) {
                console.log("[DEBUG] Nazioni retrieved with success");

                let nazioni = Utils.addFieldToArrayObjects(data.data, "descrizione", "dataInizioValidita", "dataFineValidita", "codice");
                let codiceMap = Utils.arrayToMap(nazioni, "codice");
                let italia = {
                    descrizione: "Italia",
                    codice: "100"
                }
                nazioni.push(italia)
                codiceMap["100"] = italia
                sessionStorage.setItem("nazioni", JSON.stringify(nazioni));
                sessionStorage.setItem("nazioniPerCodice", JSON.stringify(codiceMap));


                console.log("[DEBUG] Get nazioni to SessionStorage");
            }
        }).catch(
            console.log("[ERROR] Get Nazioni to SessionStorage")
        );
    }

    static getSiglaProvince() {

        axios.get(DizionariService.urlSiglaProvince).then(data => {
            if (data) {
                console.log("[DEBUG] Sigla Province retrieved with success");

                let siglaProvince = Utils.addFieldToArrayObjects(data.data, "descrizione", "dataInizioValidita", "dataFineValidita", "codice");

                sessionStorage.setItem("siglaProvince", JSON.stringify(siglaProvince));

                console.log("[DEBUG] Get Sigla Province to SessionStorage");
            }
        }).catch(
            console.log("[ERROR] Get Sigla Province to SessionStorage")
        );
    }

    static getStruttureAndStabilimenti() {

        axios.get(DizionariService.urlStruttureAndStabilimenti).then(data => {
            if (data) {
                console.log("[DEBUG] Strutture retrieved with success");
                let strutture = Utils.addFieldToArrayObjects(data.data, "codice", "descrizione", "codiceDescrizione");
                sessionStorage.setItem("struttureAndStabilimenti", JSON.stringify(strutture));
                let codiceMap = Utils.arrayToMap(strutture, "codice");
                sessionStorage.setItem("struttureAndStabilimentiPerCodice", JSON.stringify(codiceMap));
                console.log("[DEBUG] Get Strutture to SessionStorage");
            }
        }).catch(
            console.log("[ERROR] get Strutture to SessionStorage")
        );


    }

    static getReparti() {

        axios.get(DizionariService.urlReparti).then(data => {
            if (data) {
                console.log("[DEBUG] Reparti retrieved with success");

                let reparti = Utils.addFieldToArrayObjects(data.data, "codice", "descrizione", "codiceDescrizione").sort((a,b) => (a.descrizione > b.descrizione) ? 1 : ((b.descrizione > a.descrizione) ? -1 : 0));
                let repartiPerCodice = Utils.arrayToMap(reparti, "codice");

                sessionStorage.setItem("reparti", JSON.stringify(reparti));
                sessionStorage.setItem("repartiPerCodice", JSON.stringify(repartiPerCodice));

                console.log("[DEBUG] Get Reparti to SessionStorage");
            }
        }).catch(
            console.log("[ERROR] get Reparti to SessionStorage")
        );


    }

    static getAulssPerComuni() {
        axios.get(DizionariService.urlGetAulssPerComuni).then(data => {
            if (data) {
                console.log("[DEBUG] Comuni retrieved with success");
                let comuni = data.data;
                let codiceMap = Utils.arrayToMap(comuni, "codice");

                sessionStorage.setItem("comuni", JSON.stringify(comuni));
                sessionStorage.setItem("comuniPerCodice", JSON.stringify(codiceMap));
                console.log("[DEBUG] Get comuni to SessionStorage");
            }
        }).catch(
            console.log("[ERROR] Get Comuni to SessionStorage")
        );
    }

    static getComuni() {
        axios.get(DizionariService.urlComuni).then(data => {
            if (data) {
                console.log("[DEBUG] comuni retrieved with success");
                let comuni = data.data;
                localStorage.setItem("comuni", JSON.stringify(comuni));

                console.log("[DEBUG] Get comuni to LocalStorage");
            }
        }).catch(
            console.log("[ERROR] Get comuni to LocalStorage")
        );
    }

    static getComuniPerAulss() {
        axios.get(DizionariService.urlGetComuniPerAulss).then(data => {
            if (data) {
                console.log("[DEBUG] Comuni retrieved with success");
                let comuni = data.data;

                localStorage.setItem("comuniPerAulss", JSON.stringify(comuni))

                console.log("[DEBUG] Get comuni to SessionStorage");
            }
        }).catch(
            console.log("[ERROR] Get Comuni to SessionStorage")
        );
    }

    static getAulss() {
        axios.get(DizionariService.urlAulss).then(data => {
            if (data) {
                console.log("[DEBUG] Aulss retrieved with success");
                let aulss = data.data;

                localStorage.setItem("aulss", JSON.stringify(aulss))

                console.log("[DEBUG] Get aulss to LocalStorage");
            }
        }).catch(
            console.log("[ERROR] Get Aulss to LocalStorage")
        );
    }
}
